export enum FormFieldsText {
    ACCEPT = 'Accept',
    REJECT = 'Reject'
}